module.exports = __webpack_public_path__ + "img/dcom06.12980d74.png";